import { SourcingProjectRequestDetailsLineItem } from '~/common/types/SourcingProjectDetails';

export enum SourcingProjectItemStatus {
  AWARDED = 'AWARDED',
  REJECTED = 'REJECTED',
  SUBMITTED = 'SUBMITTED',
}
export enum SourcingProjectRequestItemGridColumnGroup {
  ITEM = 'item',
  AWARDING = 'awarding',
}
export type SourcingProjectRequestDetailsDataGridRow = SourcingProjectRequestDetailsLineItem;
